import { Box, Button, Grid, Hidden, Stack,Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TextFieldCustom } from '../../components/FormElements';
import { BackIcon, EyeIcon, EyeOffIcon } from '../../components/IconComponent';
import { config_path, portalCfg } from '../../router/config.path';
import PublicPage from '../PublicPage';
import Modal from '../../components/Modal';
import validators from '../../utils/validators'
import { cache } from '../../utils/cache';
import { getData } from '../../utils/common';
import InitiatePage from '../InitiatePage';
import { GetIconColor } from '../../theme/main_style';

export default function LoginWithEmailView(props) {
    const { isEmailOtp, message } = props;
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { palette } = useTheme();
    const emailData = getData('email');
    const [email, setEmail] = useState(searchParams.get("email"));
    if(!email && emailData!=null && emailData!="null"){
        setEmail(emailData);
    } 

    const onBack = ()=>{
        navigate(config_path.login_register);
    }

    let optionsColour = null;
    if (palette.secondary.background.startsWith('#fff') || palette.secondary.background.startsWith('#000') ) 
    {
        optionsColour = palette.primary.main;
    }
    else if(palette.primary.main === palette.secondary.background)
    {
        optionsColour = '#ffffff'
    }
    else{
        optionsColour = palette.primary.main;
    }

    const renderContent = () => {
        return (
            <>
                <Hidden mdUp>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:16,left:10 }} >
                        <BackIcon color={optionsColour}/>
                    </Stack>
                </Hidden>
                <Hidden mdDown>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:20,left:10 }} >
                        <BackIcon color={GetIconColor().primary}/>
                    </Stack>
                </Hidden>

                <Box
                    sx={{
                        position: {xs:'absolute', md: 'inherit'},
                        bottom: {xs:'0px', md: undefined},
                        backgroundColor: palette.background.paper,
                        borderRadius: '20px 20px 0px 0px',
                        p: 3, 
                        width: '100%',
                    }}>
                    <Grid item xs={12} marginTop={4}>
                        <Grid item xs={12}>
                            <Form
                                onSubmit={props.onSubmit}
                                render={({ handleSubmit }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid item xs={12}>
                                            <Grid item xs={12} marginY={2}>
                                                <Field
                                                    name="username"
                                                    label={t('email')}
                                                    component={TextFieldCustom}
                                                    placeholder={t('email_input_placeholder')}
                                                    isEdit={true}
                                                    isValid={true}
                                                    initialValue={email}
                                                    validate={validators.composeValidators(validators.required, validators.validEmail)}
                                                />
                                            </Grid>
                                            {!isEmailOtp && <Grid item xs={12}>
                                                <Field
                                                    name="password"
                                                    label={t('password')}
                                                    component={TextFieldCustom}
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder={t('enter_your_password')}
                                                    isEdit={true}
                                                    isValid={true}
                                                    endAdornment={<Grid item paddingTop={1} onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeIcon /> : <EyeOffIcon />}</Grid>}
                                                    validate={validators.required}
                                                />
                                            </Grid>}
                                            {!isEmailOtp && <Grid item xs={12} container justifyContent={'flex-end'}>
                                                <Button id='loginEmail/bntForgotPassword' onClick={() => navigate(config_path.forgot_password)} variant='text'>{t('forgot_password')}</Button>
                                            </Grid>}
                                            <Grid item xs={12} marginY={3}>
                                                <Button id='loginEmail/btnSubmit' size="large" sx={{borderRadius:'30px'}} fullWidth variant='contained' onClick={handleSubmit} type='submit'>{t('btn_login')}</Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </>
        )
}
    return (
        <>
            <Hidden mdUp>
                <InitiatePage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </InitiatePage>
            </Hidden>

            <Hidden mdDown>
                <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </PublicPage>
            </Hidden>
        </>
        
    )
}
